import { twJoin, twMerge } from '@troon/tailwind-preset/merge';
import type { ParentProps, JSX } from 'solid-js';

type Props = ParentProps<
	JSX.HTMLAttributes<HTMLDivElement> & {
		size?: 'default' | 'medium' | 'small' | 'xsmall';
	}
>;

export function Container(props: Props) {
	return (
		<div
			{...props}
			class={twMerge(
				twJoin(
					'container mx-auto flex w-full flex-col gap-8 px-4 sm:px-6 md:px-12',
					props.size === 'medium' && 'max-w-screen-xl lg:px-28',
					props.size === 'small' && 'max-w-screen-lg',
					props.size === 'xsmall' && 'max-w-screen-sm',
				),
				props.class,
			)}
		/>
	);
}
